import '@babel/polyfill'
// import 'es5-shim'
// import 'es6-shim'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
// import { I18nextProvider } from 'react-i18next'
import * as Sentry from '@sentry/browser'

import configureStore from './store/configureStore'
import { rootSaga } from './sagas'

import './i18n'

import App from './containers/App'
import config from './config'

import './styles/index.scss'

if (config.ENABLE_SENTRY) {
  Sentry.init({
    dsn: "https://c948db067ffe4517a892e095f1e67050@sentry.io/1760868"
  })
}

if (config.ENABLE_COOKIEYES) {
  const s = document.createElement('script')
  s.id = 'cookieyes'
  s.src = `https://cdn-cookieyes.com/client_data/${config.COOKIEYES_ID}/script.js`
  document.head.appendChild(s)
}

if (config.ENABLE_GOOGLE_ANALYTICS_LOGGING && config.GOOGLE_ANALYTICS_ID) {
  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${config.GOOGLE_ANALYTICS_ID}`
  document.head.appendChild(s)
  window.dataLayer = window.dataLayer || []
  // Must live on window: ga.js is a separate module and calls window.gtag from
  // there. A plain `function gtag()` here stays scoped to this block/module.
  window.gtag = function gtag() { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', config.GOOGLE_ANALYTICS_ID)
}

function renderApp() {
  const { store, runSaga, persistor } = configureStore()
  runSaga(rootSaga)

  const rootElement = document.getElementById('root')

  render(
    <React.Fragment>
      {/* <I18nextProvider i18n={i18n}> */}
      <PersistGate persistor={persistor}>
        <Provider store={store}>
          <App />
        </Provider>
      </PersistGate>
      {/* </I18nextProvider> */}
    </React.Fragment>,
    rootElement
  )
}

renderApp()